<template>
  <div v-if="detail != ''" class="container">
    <ul>
      <li>
        <label>项目名称：</label>
        <p>{{ detail.project_name }}</p>
      </li>
      <li>
        <label>退货网点：</label>
        <p>{{ detail.device_name }}</p>
      </li>
      <li>
        <label>退货日期：</label>
        <p>{{ detail.return_date }}</p>
      </li>
      <li>
        <label>退货员工：</label>
        <p>{{ detail.user_name }}</p>
      </li>
      <li>
        <label>退回渠道：</label>
        <p v-show="detail.return_to == 1">甲方</p>
        <p v-show="detail.return_to == 2">公司</p>
      </li>
      <li>
        <label>退回类型：</label>
        <p v-show="detail.return_type == 1">机器剩余商品</p>
        <p v-show="detail.return_type == 2">网点现有库存</p>
      </li>
      <li>
        <label>退回原因：</label>
        <p>{{ detail.reason }}</p>
      </li>
      <li>
        <label>创建时间：</label>
        <p>{{ detail.create_time }}</p>
      </li>
      <li>
        <label>修改时间：</label>
        <p>{{ detail.create_time }}</p>
      </li>
      <li>
        <label>状态：</label>
        <p v-show="detail.status == 10">待审核</p>
        <p v-show="detail.status == 20">已通过</p>
        <p v-show="detail.status == 21">已驳回</p>
      </li>
      <li v-show="detail.status == 21">
        <label>驳回原因：</label>
        <p>{{ detail.check_reason }}</p>
      </li>
      <li v-show="detail.status == 20 || detail.status == 21">
        <label>审核人：</label>
        <p>{{ detail.check_user_name }}</p>
      </li>
    </ul>
    <table>
      <thead>
        <th>商品名称</th>
        <th>商品图</th>
        <th>退回数量</th>
      </thead>
      <tbody>
        <tr v-for="(item, index) in detail.material_list" :key="index">
          <td>{{ item.brand_name }}</td>
          <td>
            <img :src="item.imageUrl.url_thumb" alt="" />
          </td>
          <td>{{ item.num }}</td>
        </tr>
      </tbody>
    </table>
    <div class="operation" v-show="detail.status == 10">
      <a-button type="primary" @click="auditPagePass">
        审核通过
      </a-button>
      <a-button type="danger" @click="auditPageReject">
        审核驳回
      </a-button>
    </div>
    <!-- 驳回 -->
    <section class="dialogsBox" v-show="rejectIsShow">
      <div>
        <h3>驳回</h3>
        <ul>
          <li>
            <label><i>*</i>驳回原因：</label>
            <a-textarea
              v-model="reason"
              placeholder="请输入驳回原因"
              style="width: 300px"
            />
          </li>
        </ul>
        <div>
          <a-button @click="rejectIsShow = false">取消</a-button>
          <a-button type="primary" @click="rejectSure">确认</a-button>
        </div>
      </div>
    </section>
    <!-- 驳回 end -->
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      detail: "",
      rejectIsShow: false,
      reason: "",
      device_return_id: ""
    };
  },
  props: {
    detailVal: {}
  },
  watch: {
    detailVal() {
      this.getDetail(this.detailVal);
    }
  },
  mounted() {
    if (this.detailVal != undefined) {
      this.getDetail(this.detailVal);
    }
  },
  methods: {
    getDetail(id) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.equipment +
        "Project_material/deviceReturnDetail";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          device_return_id: id
        })
        .then(res => {
          console.log(res);
          if (res.data.code == 200) {
            this.detail = res.data.data;
          }
        });
    },
    auditPagePass() {
      let _this = this;
      this.$confirm({
        title: "退回货品审核通过",
        content: "一旦确定，双方库存进行自动校正，是否确认操作!",
        cancelText: "取消",
        okText: "确认",
        onOk() {
          _this.orderPassOperation();
        },
        onCancel() {}
      });
    },
    orderPassOperation() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.equipment +
        "Project_material/deviceReturnPass";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          device_return_id: this.detail.id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success("审核成功");
          } else {
            this.$message.info(res.data.message);
          }
          this.$emit("hideIsDetail", true);
        })
        .catch(err => {});
    },
    auditPageReject() {
      this.rejectIsShow = true;
    },
    rejectSure() {
      if (this.reason != "" && this.reason != null) {
        this.rejectIsShow = false;
        let url =
          this.httpsBasic.url +
          this.httpsBasic.equipment +
          "Project_material/deviceReturnReject";
        axios
          .post(url, {
            token: window.localStorage.getItem("xnwfPcToken"),
            device_return_id: this.detail.id,
            check_reason: this.reason
          })
          .then(res => {
            if (res.data.code == 200) {
              this.$message.success("已驳回");
              this.$emit("hideIsDetail", true);
            } else {
              this.$message.info(res.data.message);
            }
          })
          .catch(err => {});
      } else {
        this.$message.info("请填写驳回原因");
      }
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  margin: 30px 2%;
  position: relative;
  ul {
    li {
      margin-bottom: 10px;
      p,
      label {
        display: inline-block;
        font-size: 14px;
        line-height: 24px;
      }
    }
  }
  table {
    td,
    th {
      border: 1px solid #ccc;
      padding: 4px 6px;
    }
    tr {
      img {
        height: 30px;
        width: 30px;
      }
    }
  }
  .operation {
    position: absolute;
    right: 30px;
    top: 20px;
    display: flex;
    flex-direction: column;
    button {
      margin-bottom: 16px;
    }
  }
}
</style>
